module.exports = __webpack_public_path__ + "img/EXTERIOR-ERTIGA-3.f4aeb6ca.jpg";